import { render, staticRenderFns } from "./Region.vue.js?vue&type=template&id=18c52dc7&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Region.vue?vue&type=template&id=18c52dc7&scoped=true"
import script from "./Region.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Region.vue?vue&type=script&lang=js"
export * from "./Region.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Region.vue?vue&type=script&lang=js"
import style0 from "./Region.vue.css?vue&type=style&index=0&id=18c52dc7&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Region.vue?vue&type=style&index=0&id=18c52dc7&prod&lang=css"
import style1 from "./Region.vue.less?vue&type=style&index=1&id=18c52dc7&prod&lang=less&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Region.vue?vue&type=style&index=1&id=18c52dc7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c52dc7",
  null
  
)

export default component.exports